import React from 'react';
import { ScrollSyncPane } from 'react-scroll-sync';
import styled from 'styled-components';
import { TABLE_Z_INDEX } from './HBTable.styles';

interface HBTableFloatingScrollerProps {
    setScrollerEl: (el: HTMLDivElement) => void;
}

function HBTableFloatingScroller({
    setScrollerEl
}: HBTableFloatingScrollerProps) {
    return (
        <ScrollSyncPane>
            <Container>
                <Inner ref={setScrollerEl} />
            </Container>
        </ScrollSyncPane>
    );
}

export default HBTableFloatingScroller;

// -------------------------- Styles -------------------------- //

const Container = styled.div`
    position: sticky;
    bottom: 0;
    z-index: ${TABLE_Z_INDEX.BOTTOM};
    overflow: auto hidden;
    margin-top: -24px;
    height: 24px;
`;

const Inner = styled.div`
    height: 1px;
`;
